import {css, html, LitElement} from 'lit';
import {customElement, property} from 'lit/decorators';
import {containerStyles, normalizeStyles, typographyStyles} from "@webs/components-library/theming";

@customElement('webs-card-value')
export class CardValue extends LitElement {

  static styles = [
    normalizeStyles,
    typographyStyles,
    containerStyles,
    css`
        .m-card-value {
          position: relative;
        }

        .m-card-value__side {
          background: var(--color-light-grey);
          height: 100%;
          border-radius: 16px;
          transition: all 1s ease;
          backface-visibility: hidden;
          text-align: center;
          padding: 1rem 0.8rem 1.6rem 0.8rem;
          display: flex;
          flex-direction: column;
       }

       .m-card-value__side-back {
          overflow: hidden;
          padding: 2rem 1.2rem 1.6rem 1.2rem;
           transform: rotateY(180deg);
           width: 100%;
          position: absolute;
          left: 0;
          top: 0;
          bottom: 0;
       }

       .m-card-value__side-front-label {
          font-size: 1.1rem;
          line-height: 1.3;
          margin-top: 0.75rem;
          margin-bottom: 0;
          color: inherit
       }

       h3.m-card-value__side-front-title {
          margin-top: 1.2rem;
          margin-bottom: 0;
          font-size: 2rem;
          line-height: 1.2;
          font-weight: var(--font-weight-light);
       }

       h3.m-card-value__side-back-title {
          margin-top: 1.2rem;
          margin-bottom: 0;
          font-size: 1.4rem;
          line-height: 1.3;
          font-weight: var(--font-weight-light);
       }



       .m-card-value__side-front-description {
          font-size: 1.2rem;
          line-height: 1.3;
          opacity: 0.8;
          margin-top: 0.4rem;
          color: var(--color-grey);
       }

       .m-card-value__side-back-description {
          margin-top: .4rem;
          margin-bottom: auto;
       }


       .m-card-value__side-front-icon {
          display: block;
          margin: 0 auto;
          margin-top: 1.7rem;
          width: 63px;
          height: 55px;
       }

       .m-card-value__side-front-icon.icon-variant {
          display: none;
       }

       .m-card-value__side-front-icon img {
          display: block;
          width: 100%;
          height: 100%;
       }

       .m-card-value__side-button-front {
          font-size: .8rem;
          line-height: 1.2;
          font-weight: var(--font-weight-strong);
          font-family: var(--font-family-alternative);
          margin-top: 1.3rem;
          cursor: pointer;

       }

       .m-card-value__side-button-back {
          font-size: .8rem;
          line-height: 1.2;
          font-weight: var(--font-weight-strong);
          font-family: var(--font-family-alternative);
          margin-top: 0.9rem;
          cursor: pointer;

       }

         .flipped.m-card-value__side-front  {
           transform: rotateY(-180deg);
         }

       .flipped.m-card-value__side-back  {
          transform: rotateY(0);
        }


   @media only screen and (min-width: 992px){


       h3.m-card-value__side-front-title {
        margin-top: 1.6rem;
       }

       h3.m-card-value__side-back-title {
          margin-top: 0;
       }

       .m-card-value__side-back-description {
           margin-top: 1.6rem;
          margin-bottom: auto;
          font-size:1.1rem;
          line-height: 1.3;
       }

         .m-card-value__side-front-icon {
          margin-top: 4rem;
          width: 95px;
          height: 83px;
       }

       .m-card-value__side {
              padding: 2rem 1.25rem 4.8rem 1.25rem;
          }

         .m-card-value:hover .m-card-value__side-front  {
          cursor: pointer;
          transform: rotateY(-180deg);
        }

        .m-card-value:hover .m-card-value__side-back  {
          cursor: pointer;
            transform: rotateY(0);
        }

         .m-card-value__side-button-front {
          display: none;
        }

        .m-card-value__side-button-back  {
           display: none;
        }
      }
    `
  ];

  @property()
  label: string;

  @property()
  title: string;

  @property({attribute: "short-description"})
  shortDescription: string;

  @property()
  description: string;

  @property()
  icon: string;

  @property({attribute: 'icon-variant'})
  iconVariant: string;

  @property({attribute: 'text-front'})
  textFront: string;

  @property({attribute: 'text-back'})
  textBack: string;

  protected render(): unknown {
    return html`
      <div class="m-card-value">
        <div part="card" class="m-card-value__side  m-card-value__side-front">
            ${this.label ? html`<p part="card-label" class="m-card-value__side-front-label ">${this.label}</p>` : ''}
            ${this.title ? html`<h3 part="card-title" class="m-card-value__side-front-title ">${this.title}</h3>` : ''}
            ${this.shortDescription ? html`<p part="card-description" class="m-card-value__side-front-description ">${this.shortDescription}</p>` : ''}
            ${this.icon ? html`<picture part="card-icon" class="m-card-value__side-front-icon"><img class="media_image-responsive" src="${this.icon}" alt="Icon" loading="lazy" width="95"></picture>` : ''}
            ${this.iconVariant ? html`<picture part="card-icon-variant" class="m-card-value__side-front-icon icon-variant"><img class="media_image-responsive" src="${this.iconVariant}" alt="Icon" loading="lazy" width="95"></picture>` : ''}
             <a part="card-button" class="m-card-value__side-button-front" @click="${this.flipCard}">
               ${this.textFront ? this.textFront : ''}
             </a>
        </div>
        <div part="card" class="m-card-value__side m-card-value__side-back">
          ${this.title ? html`<h3 part="card-title" class="m-card-value__side-back-title ">${this.title}</h3>` : ''}
          ${this.description ? html`<p part="card-description" class="m-card-value__side-back-description ">${this.description}</p>` : ''}
          <a part="card-button" class="m-card-value__side-button-back" @click="${this.flipCardBack}">
            ${this.textBack ? this.textBack : ''}
          </a>
        </div>
      </div>

    `
  }

  private flipCard() {
    const front = this.shadowRoot.querySelector('.m-card-value__side-front');
    const back = this.shadowRoot.querySelector('.m-card-value__side-back');
    console.log(front)
    front.className += ' flipped'
    back.className += ' flipped'
  }

  private flipCardBack() {
    const front = this.shadowRoot.querySelector('.m-card-value__side-front');
    const back = this.shadowRoot.querySelector('.m-card-value__side-back');
    front.classList.remove('flipped');
    back.classList.remove('flipped');
  }

}
